import { ModalFuncProps } from 'antd'
import styles from './index.module.scss'
import { ReactComponent as CloseModalIcon } from '@/assets/icons/closeModal.svg'
import { ReactComponent as HintIcon } from '@/assets/icons/hint.svg'
import cls from 'classnames'

type ModalMethod = 'info' | 'confirm'

const open = (method: ModalMethod, options: ModalFuncProps = {}) => {
  return window.shModal[method]({
    width: 500,
    className: styles.container,
    closeIcon: <CloseModalIcon />,
    ...options,
    content: (
      <div
        className={cls({
          [styles.content]: true,
          [styles.confirm]: method === 'confirm',
        })}
      >
        {options.content}
      </div>
    ),
    icon:
      options.icon === null ? null : (
        <div className={styles.icon}>{options.icon || <HintIcon />}</div>
      ),
  })
}

export default {
  info: open.bind(null, 'info'),
  confirm: open.bind(null, 'confirm'),
}
